export function useHelper() {
  const controlObject = (object) => {
    for (const key in object) {
      if (!object[key]) {
        delete object[key];
      }
    }
  };

  const getAgeFromBirthday = (birthday) => {
    const ageDifMs = Date.now() - new Date(birthday).getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const transformFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const canvas = document.createElement("canvas");
        const img = document.createElement("img");
        img.src = reader.result;
        img.onload = () => {
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          ctx.fillStyle = "red";
          ctx.textBaseline = "middle";
          ctx.fillText("Ant Design", 20, 20);
          canvas.toBlob(resolve);
        };
      };
    });
  };
  const groupSkills = (skills) => {
    if (!skills?.length) return [];
  
    const formattedSkills = [];
    const allSkillTypes = ["language", "soft", "certified", "technical"];
  
    for (const skillType of allSkillTypes) {
      const filteredSkills = skills.filter(
        (skill) => skill.skill_type === skillType && skill.name
      );
  
      if (filteredSkills.length > 0) {
        const skillNames = filteredSkills.map((skill) => skill.name).join(", ");
        formattedSkills.push({
          name: skillNames || "-",
          skill_type: skillType,
        });
      }
    }
  
    return formattedSkills;
  };
  
  
  const groupService = (service) => {
    if (!service?.length) return [];

    const formattedService = service
      ?.map((serv) => serv.name || "-")
      .join(", ");

    return formattedService;
  };

  const getUrlExtension = (url) => {
    return url.split(/[#?]/)[0].split(".").pop().trim();
  };

  async function dataURLtoFile(dataurl) {
    const response = await fetch(dataurl);
    const contentType = response.headers.get("content-type");
    const imgExt = getUrlExtension(dataurl);
    const blob = await response.blob();
    const file = new File([blob], `logo.${imgExt}`, { contentType });
    return file;
  }

  return {
    controlObject,
    dataURLtoFile,
    getUrlExtension,
    transformFile,
    getAgeFromBirthday,
    groupSkills,
    groupService,
  };
}
